const ObjectUtils = {
    /**
     * Check if an object has any value that is not undefined
     * @param {object} obj
     */
    isObjValuesEmpty: (obj) => Object.values(obj).reduce((out, v) => out && !v, true),

    /**
     * Extract values from one object, creating a new object
     * @param {Object} origin Object to copy fields from
     * @param @readonly {Array<String>} fields Array of key to be taken from original object
     * @param {Object} map Object with functions to transform every field to be copied, indexed by key
     */
    copy: (origin, fields, map = {}) => {
        const getMapFunc = (field) => (typeof map[field] === 'function' ? map[field] : (val) => val)

        const fieldsToTake = fields || Object.keys(origin)

        return fieldsToTake.reduce((obj, field) => {
            const output = obj
            const t = getMapFunc(field)
            output[field] = t(origin[field])
            return output
        }, {})
    },
}

export default ObjectUtils
